import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import ChatBot, { Loading } from 'react-simple-chatbot';

class CheckReq extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      result: '',
      trigger: false,
    };

    this.triggetNext = this.triggetNext.bind(this);
  }

  componentWillMount() {
    const self = this;
    const { steps } = this.props;
    const check = steps.check.value;

    axios.get('http://covid19.cristianlai.it/chatbot?query=' + check)
            .then(res => {
                self.setState({ loading: false, result: res.data });
                console.log(res.data);
            })
            .catch(err => {
                self.setState({ loading: false, error: err.message });
            })

  }

  triggetNext() {
    this.setState({ trigger: true }, () => {
      this.props.triggerNextStep();
    });
  }

  render() {
    const { trigger, loading, result } = this.state;

      if (!loading) {
        return (
          <div style={{ width: '100%' }}>
            <table>
              <tbody>
                <tr>

                  <td>{result.message}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      } else {
            return (
                <div>
                    Loading...
                </div>
            );
        }
  }
}

CheckReq.propTypes = {
  steps: PropTypes.object,
  triggerNextStep: PropTypes.func,
};

CheckReq.defaultProps = {
  steps: undefined,
  triggerNextStep: undefined,
};

export default CheckReq;
